enum AssetValuationMethodType {
    MSRP = 'MSRP',
    AVERAGE_RETAIL = 'Average Retail',
    MANUFACTURER_PRICE = 'Manufacturer Price',
    WHOLESALE_PRICE = 'Wholesale Price',
    SALES_PRICE = 'Sales Price',
    VEHICLE_PRICE = 'Vehicle Price',
}

export default AssetValuationMethodType
